// extracted by mini-css-extract-plugin
export default {"list":"TasksColumnList_list__CUORp","listItem":"TasksColumnList_listItem__7Hec8"};